// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blank-slate-pf{margin-top:100px !important}`, "",{"version":3,"sources":["webpack://./webpack/assets/javascripts/react_app/routes/common/EmptyPage/emptypage.scss"],"names":[],"mappings":"AAAA,gBACE,2BAAA","sourcesContent":[".blank-slate-pf {\n  margin-top: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
